import {
  HistoryEducationModel,
  HistoryEducationItemModel,
  HistoryEducationDiplomaModel
} from 'forms/sections/history/education/types';
import {
  LocationModel,
  ListModel,
  BranchCollectionModel,
} from 'forms/shared/types';
import * as form from '../form';

function parsePhysicalLocations(PhysicalLocations: BranchCollectionModel<LocationModel>) {
  const items = PhysicalLocations?.items || [];
  return form.collection( // PVQ Only
    items.map((item) => {
      const { Item } = item;
      return {
        Item: {
          Has: form.branch(Item?.Has),
          Location: form.location(Item?.Location)
        },
      };
    })
  );
}

function parseDiplomas(Diplomas: BranchCollectionModel<HistoryEducationDiplomaModel>) {
  const items = Diplomas?.items || [];
  return form.collection(
    items.map((item) => {
      const { Item } = item;
      return {
        Item: {
          Has: form.branch(Item?.Has),
          Diploma: form.radio(Item?.Diploma),
          DiplomaOther: form.text(Item?.DiplomaOther),
          Date: form.datecontrol(Item?.Date),
        },
      };
    })
  );
}

function parseEducationList(EducationList: ListModel<HistoryEducationItemModel>) {
  const items = EducationList?.items || [];
  return items.map((item) => {
    const { Item } = item;
    return {
      Item: {
        Dates: form.daterange(Item?.Dates),
        Type: form.radio(Item?.Type),
        TypeOtherExplanation: form.textarea(Item?.TypeOtherExplanation),
        Name: form.text(Item?.Name),
        Address: form.location(Item?.Address),
        Comments: form.textarea(Item?.Comments),
        ReferenceComments: form.textarea(Item?.ReferenceComments),
        DiplomasAnswerComments: form.textarea(Item?.DiplomasAnswerComments),
        DegreesAwardedComments: form.textarea(Item?.DegreesAwardedComments),
        ReferenceName: form.name(Item?.ReferenceName),
        ReferenceNameNotApplicable: form.notapplicable(Item?.ReferenceNameNotApplicable),
        ReferencePhone: form.telephone(Item?.ReferencePhone),
        ReferencePhones: form.collection(form.telephoneCollection(Item?.ReferencePhones)),
        ReferencePhoneNotApplicable: form.notapplicable(Item?.ReferencePhoneNotApplicable),
        ReferenceEmailNotApplicable: form.notapplicable(Item?.ReferenceEmailNotApplicable),
        ReferenceEmail: form.email(Item?.ReferenceEmail),
        ReferenceEmails: form.collection(form.emailCollection(Item?.ReferenceEmails)),
        ReferenceAddress: form.location(Item?.ReferenceAddress),
        ReferenceAddressNotApplicable: form.notapplicable(Item?.ReferenceAddressNotApplicable),
        ReferenceType: form.checkboxgroup(Item?.ReferenceType), // PVQ Only
        ReferenceTypeOtherExplanation: form.textarea(Item?.ReferenceTypeOtherExplanation), // PVQ Only
        OutOfBusiness: form.checkbox(Item?.OutOfBusiness), // PVQ Only
        LearningExperience: form.radio(Item?.LearningExperience), // PVQ Only
        LearningExperienceOtherExplanation: form.textarea(Item?.LearningExperienceOtherExplanation), // PVQ Only
        PhysicalLocations: parsePhysicalLocations(Item?.PhysicalLocations),
        Diplomas: parseDiplomas(Item?.Diplomas),
      }
    };
  });
}

const emptyHistoryEducationModel = {} as HistoryEducationModel;

export const historyEducation = (data: HistoryEducationModel = emptyHistoryEducationModel) => ({
  HasAttended: form.branch(data?.HasAttended),
  HasDegree10: form.branch(data?.HasDegree10),
  AttendedComments: form.textarea(data?.AttendedComments),
  HasDegreeComments: form.textarea(data?.HasDegreeComments),
  SummaryComments: form.textarea(data?.SummaryComments),
  List: form.collection(parseEducationList(data?.List), (data?.List || {}).branch),
  ListDegrees: form.collection(parseEducationList(data?.ListDegrees), (data?.ListDegrees || {}).branch),
});
